export default {
    icon: "dashboard",
    layout: "dashboard",
    url: "/",
    title: "Dashboard"
};